<ng-container *ngIf="marketDropdownOptions$ | async as markets">
  <glxy-form-field *ngIf="markets?.length > 1" bottomSpacing="false" minWidth="200px" maxWidth="200px">
    <mat-select [value]="selectedMarketId$ | async" (selectionChange)="handleMarketIdChange($event)">
      <mat-option *ngFor="let market of markets" [value]="market.market_id">
        {{ market.name }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
</ng-container>
